export class CareGroupUser {
  id?: number;
  careGroupId: number;
  userId?: number;
  role?: string;
}
